<template>
  <div class="w-full">
    <!-- Cabecera -->
    <div class="bg-white p-4 h-[68px] rounded-lg shadow-md">
      <!-- Estructura original para pantallas grandes -->
      <div class="hidden sm:flex flex-wrap mb-4">
        <div class="flex flex-1 items-center">
          <fwb-heading tag="h2" class="text-style-xl">Formulario Motivo</fwb-heading>
        </div>
        <div class="flex flex-1 justify-end items-center">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/reports/reasons" class="custom-alert-text">
              Lista de Motivos
            </fwb-breadcrumb-item>
            <fwb-breadcrumb class="custom-alert-text">
              {{ isEditing ? "/ Editar Motivo" : "/ Crear Motivo" }}
            </fwb-breadcrumb>
          </fwb-breadcrumb>
        </div>
      </div>

      <!-- Estructura para móviles (se muestra solo en sm y menores) -->
      <div class="sm:hidden flex items-center h-full gap-2">
        <div class="flex-1 min-w-0 overflow-hidden custom-alert-text h-full">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/reports/reasons" class="custom-alert-text">
              Lista de Motivos
            </fwb-breadcrumb-item>
            <fwb-breadcrumb class="custom-alert-text">
              {{ isEditing ? "/ Editar Motivo" : "/ Crear Motivo" }}
            </fwb-breadcrumb>
          </fwb-breadcrumb>
        </div>
      </div>

      <head>
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
      </head>
    </div>
    
    <!-- Contenedor para el formulario -->
    <div class="mx-auto p-4 px-0">
      <div class="flex flex-wrap">
        <div class="w-full rounded overflow-hidden shadow-lg bg-white p-6 px-3">
          <FormReasonsReportsComponent />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
  import { FwbBreadcrumb, FwbBreadcrumbItem, FwbHeading } from 'flowbite-vue';
  import { ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import FormReasonsReportsComponent from '@/components/reports/FormReasonsReportsComponent.vue';

  const route = useRoute();
  const isEditing = ref(!!route.params.id);

  // Observar cambios en la ruta para actualizar el estado de edición
  watch(() => route.params.id, (newId) => {
    isEditing.value = !!newId;
  });
  </script>
  
  <style scoped>
  /* Estos estilos solo se aplicarán en móvil */
  @media (max-width: 639px) {
    .custom-alert-text {
      font-size: 0.75rem;
      line-height: 1rem;
    }
    .text-style-xl {
      font-size: 1rem;
      line-height: 1rem;
    }
  }
  </style>